// Unpublished Work © 2023 Deere & Company.
import LocalStorage from "./LocalStorage";

type legacyHome = boolean;

export const saveLegacyHome = (value: boolean) =>
  LocalStorage.setJSONValue("legacyHome", { value });

const getStoredLegacyHome = (): legacyHome | undefined =>
  LocalStorage.getJSONValue("legacyHome")?.value === true;

const getLegacyHomeFromUrl = (): legacyHome | undefined => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get("legacyHome")?.toLowerCase() === "true";
};

export const getLegacyStatus = (): legacyHome => {
  const legacyHome =
    [getLegacyHomeFromUrl(), getStoredLegacyHome()].find((status) => status) ||
    false;
  saveLegacyHome(legacyHome);
  return legacyHome;
};

export const getHomeUrl = (
  javaURL: string,
  legacyURL: string,
  dealerId: string | null,
  enableRemoveDashboardTab?: boolean
): string => {
  if (enableRemoveDashboardTab) {
    return "/home";
  }
  const accountIdParam = dealerId ? `?accountID=${btoa(dealerId)}` : "";
  return getLegacyStatus()
    ? `${legacyURL}/dns/loadMain.con${accountIdParam}`
    : `${javaURL}/dns/loadMain.con`;
};
